<ng-template #dropdownPanel>
  <div
    class="dropdown-panel enter-animation"
    [class.has-custom-template]="!!customItemTemplate"
    [class.mobile]="isMobile()"
  >
    @if (isMobile()) {
      <button
        class="mobile-close-btn"
        (click)="close()"
      >
        <i-feather name="x"></i-feather>
      </button>
    }
    <ng-content></ng-content>
    <ul>
      @for (item of items(); track item.value; let i = $index) {
        @if (item.value === 'separator') {
          <li class="separator"></li>
        } @else {
          <li
            (click)="!item.data?.['disabled'] && handleItemClick(item)"
            (keydown.enter)="!item.data?.['disabled'] && handleItemClick(item)"
            (mousedown)="onItemMouseDown(item, $event)"
            tabindex="0"
            class="dropdown-item"
            [class.selected]="item.value === selectedValue()"
            [class.disabled]="item.data?.['disabled']"
            [attr.aria-disabled]="item.data?.['disabled'] ? 'true' : 'false'"
          >
            @if (customItemTemplate) {
              <ng-container
                [ngTemplateOutlet]="customItemTemplate"
                [ngTemplateOutletContext]="{ $implicit: item, index: i }"
              ></ng-container>
            } @else {
              @if (item.svgUrl) {
                <img
                  [src]="item.svgUrl"
                  alt="icon"
                  height="15"
                  style="border-radius: 2px"
                />
              }
              @if (item.iconName) {
                <i-feather [name]="item.iconName"></i-feather>
              }
              {{ item.label }}
            }
          </li>
        }
      }
    </ul>
  </div>
</ng-template>
